import React from 'react'
import './Contact.css'

const Contact = () => {
  return (
    <div>
        <div className="social-media">
        <h1 id='h1'>Contact Us</h1>

        <div className="icons">
        <i className="fa fa-whatsapp contact-fa"></i>
        </div>
        <div className="icons">
        <i className="fa fa-instagram contact-fa"></i>
        </div>
        <div className="icons">
        <i className="fa fa-telegram contact-fa"></i>
        </div>
        <div className="icons">
        <i className="fa fa-phone contact-fa"></i>
        </div>
        <div className="icons">
        <i className="fa fa-solid fa-envelope contact-fa"></i>
        </div>
        <div className="icons">
        <i className="fa fa-map-marker contact-fa"></i>
        </div>
        </div>
        
    </div>
  )
}

export default Contact